import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { ReferenceBook } from '@/features/organizations/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const disconnectionReasonsApi = createApi({
  reducerPath: 'disconnectionReasonsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/disconnection-reasons`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => {
    return {
      getDisconnectionReasons: builder.query<ReferenceBook[], void>({
        query: () => ({
          url: ``,
        }),
      }),
    };
  },
});

export const { useGetDisconnectionReasonsQuery } = disconnectionReasonsApi;
